import { Component } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ContactUsStateService } from './state/contact-us.state-service';
import { Router } from '@angular/router';
import { OnScreenMessagingService } from '@pattern-library/onscreen-messaging/onscreen-messaging.service';
import { AuthLayoutComponent } from '../../layout/auth-layout.component';
import { InputComponent } from '@design-system/forms/input/input.component';
import { ButtonComponent } from '@design-system/buttons/button/button.component';
import { H3Component } from '@design-system/typography/h3/h3.component';
import { CommonModule } from '@angular/common';
import { TestIdDirective } from '@design-system/core/test-id.directive';

@Component({
  selector: 'app-contact-us-form',
  templateUrl: './contact-us-form.component.html',
  styleUrls: ['./contact-us-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthLayoutComponent,
    InputComponent,
    ButtonComponent,
    H3Component,
    TestIdDirective
  ],
  providers: [
    ContactUsStateService
  ]
})
export class ContactUsFormComponent {
  public form!: FormGroup;
  public isSubmitting = false;

  constructor(public stateService: ContactUsStateService, private router: Router, private messaging: OnScreenMessagingService) {
    this.stateService.setUpForm();
  }
  
  onSubmit(): void {
    this.stateService.persist$().subscribe(() => {
      const hasValidationErrors = this.stateService.serverValidationErrors;
      if (!hasValidationErrors) {
        //REDIRECT TO HOME PAGE and show success message
        this.messaging.success('Contact Us submitted successfully');
        this.return();
      }
    });
  }

  return(): void {
    this.router.navigate(['/auth', { outlets: { top: ['sign-in'] } }]);
  }
} 